import { useNavigate } from 'react-router-dom';
import '../../styles/ProfileCompletionPrompt.scss';

const ProfileCompletionPrompt = ({
  open,
  variant = 'required',
  onClose,
  onDontShowAgain
}) => {
  const navigate = useNavigate();

  if (!open) return null;

  const isReminder = variant === 'reminder';
  const title = isReminder ? 'Complete your seller profile' : 'Complete your profile';
  const message = isReminder
    ? 'You can switch to seller mode now, but completing your profile helps buyers trust and pay you.'
    : 'Please complete your profile before continuing.';

  const goToProfile = () => {
    onClose?.();
    navigate('/seller/editProfile');
  };

  const handleDontShowAgain = (event) => {
    if (event.target.checked) onDontShowAgain?.();
  };

  return (
    <div className="profile-completion-overlay" role="presentation">
      <div className="profile-completion-modal" role="dialog" aria-modal="true" aria-labelledby="profile-completion-title">
        <button className="profile-completion-close" type="button" onClick={onClose} aria-label="Close">
          &times;
        </button>
        <h2 id="profile-completion-title">{title}</h2>
        <p>{message}</p>
        {isReminder && (
          <label className="profile-completion-checkbox">
            <input type="checkbox" onChange={handleDontShowAgain} />
            <span>Don't show this again</span>
          </label>
        )}
        <div className="profile-completion-actions">
          <button className="profile-completion-secondary" type="button" onClick={onClose}>
            {isReminder ? 'Later' : 'Cancel'}
          </button>
          <button className="profile-completion-primary" type="button" onClick={goToProfile}>
            {isReminder ? 'Complete now' : 'Complete profile'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProfileCompletionPrompt;
